<template>
    <v-btn
        class="mt-2"
        min-width="250"
        color="oug"
        outlined
        elevation="24"
        @click="OpenChat"
        >
        {{ title }}
    </v-btn>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "Need Help ?",
        },
    },
    methods: {
        OpenChat() {
            console.log(this.title)
            if (localStorage.getItem("Coach")) {
                window.zE('webWidget', 'prefill', {
                name: {
                    value: `${JSON.parse(localStorage.getItem("Coach")).contact.Firstname} ${JSON.parse(localStorage.getItem("Coach")).contact.Surname}`,
                    readOnly: true // optional
                },
                email: {
                    value: `${JSON.parse(localStorage.getItem("Coach")).contact.Email_Details}`,
                    readOnly: true // optional
                },
                // TODO Add a default Phone to teh Contact Record
                // phone: {
                //   value: JSON.parse(localStorage.getItem("Referee")).contact.Default_Phone,
                //   readOnly: true // optional
                // }
                });
            }
            window.zE('webWidget', 'show');
            window.zE('webWidget', 'open');
            window.zE('webWidget:on', 'close', function () {
                window.zE('webWidget', 'hide');
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>